import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
import './Login.css';
import DefaultData from '../CompanyData/DefaultData';
import countries from '../Data/Countries.json';
import currencies from '../Data/Currency.json';
import { Row, Col } from 'react-bootstrap';
import { LandingContext } from '../Components/Profile/LandingContext';

const initialValues = {
    companyName: "",
    brandName: "",
    email: "",
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
    country: "India",
    currency: "INR",
    companyType: DefaultData.COMPANYTYPE,
    parentCompanyId: DefaultData.DEFAULTCOMPANYID,
    isActive: false,
    password: "",
    confirmPassword: "",
};

export default function AgentRegister() {
    const navigate = useNavigate();
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [apiError, setApiError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const landingData = useContext(LandingContext);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: undefined }));
        }
    };

    // Your validation is good, no changes needed here.
    const validate = () => {
        let tempErrors = {};
        if (!values.companyName.trim()) tempErrors.companyName = "Company name is required.";
        if (!values.email.trim()) {
            tempErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(values.email)) {
            tempErrors.email = "Please enter a valid email address.";
        }
        if (!values.phoneNumber.trim()) tempErrors.phoneNumber = "Phone number is required.";
        if (!values.password) {
            tempErrors.password = "Password is required.";
        } else if (values.password.length < 6) {
            tempErrors.password = "Password must be at least 6 characters.";
        }
        if (values.password !== values.confirmPassword) {
            tempErrors.confirmPassword = "Passwords do not match.";
        }
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setApiError('');
        setSuccessMessage('');

        if (validate()) {
            setIsLoading(true);

            const payload = {
                companyName: values.companyName,
                brandName: values.brandName,
                email: values.email,
                phoneNumber: values.phoneNumber,
                address: values.address,
                city: values.city,
                state: values.state,
                country: values.country,
                currency: values.currency,
                companyType: DefaultData.COMPANYTYPE,
                parentCompanyId: DefaultData.DEFAULTCOMPANYID,
                isActive: values.isActive,
                password: values.password,
                roleName: DefaultData.companyType,
                planType: DefaultData.PLANTYPE,
                userType: DefaultData.USERTYPE
            };
            try {

                await apiService.create(config.REGISTERCOMPANY, payload);
                setSuccessMessage("Registration successful! We will notify once account is approved.");
                /* setTimeout(() => {
                    navigate("/"); // Redirect to the login page after success
                }, 3000); */
            } catch (err) {
                // Better error handling based on potential backend responses
                const errorMessage = err.response?.data?.message || "Registration failed. This email or phone number may already be in use.";
                setApiError(errorMessage);
            } finally {
                setIsLoading(false);
            }
        }
    };
    const pageStyles = {
        '--theme-primary-color': DefaultData.THEMECOLOR1,
        '--theme-secondary-color': DefaultData.THEMECOLOR2
    };


    const applyErrorClass = (field) => (errors[field] ? 'is-invalid' : '');

    return (
        <>

            <div style={pageStyles}>
                <div className="auth-back-cover">
                    <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center">
                        <div className="auth-page-content overflow-hidden">
                            <div className="container">
                                <div className="row mt-5 align-items-center">
                                    <div className="col-lg-6 d-none d-lg-block">
                                        <div className="main-banner">
                                            <h1>Empowering the Future of Travel Booking</h1>
                                            <p>One stop solution for your travel business</p>
                                            <div className="vector-images">
                                                <div className="vector-item"><span><i className="ri-plane-line" /></span><p>Flights</p></div>
                                                <div className="vector-item"><span><i className="ri-building-line" /></span><p>Hotels</p></div>
                                                <div className="vector-item"><span><i className="ri-car-line" /></span><p>Cars</p></div>
                                                <div className="vector-item"><span><i className="ri-bus-line" /></span><p>Bus</p></div>
                                                <div className="vector-item"><span><i className="ri-luggage-deposit-line" /></span><p>Holidays</p></div>
                                                <div className="vector-item"><span><i className="ri-book-line" /></span><p>Visas</p></div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Right side Registration Form */}
                                    <div className="col-lg-6">
                                        <div className="card overflow-hidden rounded-4 loginbox">
                                            <div className="p-lg-5 p-4">
                                                <h3 className='text-center'>AGENT REGISTRATION</h3>
                                                <p className="text-muted text-center">Create your travel agent account.</p>

                                                {apiError && <div className="alert alert-danger">{apiError}</div>}
                                                {successMessage && <div className="alert alert-success">{successMessage}</div>}

                                                <form onSubmit={handleSubmit} noValidate>
                                                    <Row>
                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">Company Name*</label>
                                                            <input type="text" name="companyName" value={values.companyName} onChange={handleInputChange} className={`form-control ${applyErrorClass('companyName')}`} />
                                                            {errors.companyName && <div className="invalid-feedback d-block">{errors.companyName}</div>}
                                                        </Col>
                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">Brand Name</label>
                                                            <input type="text" name="brandName" value={values.brandName} onChange={handleInputChange} className="form-control" />
                                                        </Col>
                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">Email Address*</label>
                                                            <input type="email" name="email" value={values.email} onChange={handleInputChange} className={`form-control ${applyErrorClass('email')}`} />
                                                            {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
                                                        </Col>
                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">Phone Number*</label>
                                                            <input type="tel" name="phoneNumber" value={values.phoneNumber} onChange={handleInputChange} className={`form-control ${applyErrorClass('phoneNumber')}`} />
                                                            {errors.phoneNumber && <div className="invalid-feedback d-block">{errors.phoneNumber}</div>}
                                                        </Col>

                                                        <Col md={12} className="mb-3">
                                                            <label className="form-label">Address</label>
                                                            <input type="text" name="address" value={values.address} onChange={handleInputChange} className="form-control" />
                                                        </Col>
                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">City</label>
                                                            <input type="text" name="city" value={values.city} onChange={handleInputChange} className="form-control" />
                                                        </Col>
                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">State</label>
                                                            <input type="text" name="state" onChange={handleInputChange} className="form-control" />
                                                        </Col>

                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">Country*</label>
                                                            <select name="country" value={values.country} onChange={handleInputChange} className={`form-select ${applyErrorClass('country')}`}>
                                                                {countries.map(c => <option key={c.code} value={c.name}>{c.name}</option>)}
                                                            </select>
                                                        </Col>
                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">Currency*</label>
                                                            <select name="currency" value={values.currency} onChange={handleInputChange} className={`form-select ${applyErrorClass('currency')}`}>
                                                                {currencies.map(c => <option key={c.code} value={c.code}>{c.name} ({c.code})</option>)}
                                                            </select>
                                                        </Col>

                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">Password*</label>
                                                            <div className="position-relative">
                                                                <input type={showPassword ? 'text' : 'password'} name="password" value={values.password} onChange={handleInputChange} className={`form-control ${applyErrorClass('password')}`} />
                                                                <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}><i className={showPassword ? "ri-eye-fill" : "ri-eye-off-fill"}></i></span>
                                                            </div>
                                                            {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
                                                        </Col>
                                                        <Col md={6} className="mb-3">
                                                            <label className="form-label">Confirm Password*</label>
                                                            <div className="position-relative">
                                                                <input type={showConfirmPassword ? 'text' : 'password'} name="confirmPassword" value={values.confirmPassword} onChange={handleInputChange} className={`form-control ${applyErrorClass('confirmPassword')}`} />
                                                                <span className="password-toggle-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}><i className={showConfirmPassword ? "ri-eye-fill" : "ri-eye-off-fill"}></i></span>
                                                            </div>
                                                            {errors.confirmPassword && <div className="invalid-feedback d-block">{errors.confirmPassword}</div>}
                                                        </Col>
                                                    </Row>
                                                    <div className="mt-4">
                                                        <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                                                            {isLoading ? 'Submitting Application...' : 'Register'}
                                                        </button>
                                                    </div>
                                                </form>
                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">Already have an account?{" "}
                                                        <Link to="/" className="fw-semibold text-primary text-decoration-underline">Sign In</Link>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    );
}